import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { getSpace } from '../api/getSpace';
import { listUserSpaces } from '../api/listUserSpaces';
import { CompanySpacesService } from '../service/CompanySpacesService';

const spacesQueries = {
  all: () =>
    queryOptions({
      queryKey: ['spaces'],
      queryFn: listUserSpaces,
    }),
  list: (spaceId: string) =>
    queryOptions({
      queryKey: [...spacesQueries.all().queryKey, spaceId],
      queryFn: () => getSpace({ spaceId }),
    }),
};

type UpdateCompanySpaceInput = {
  companyId: string;
  body: Parameters<typeof CompanySpacesService.updateCompanySpace>[1];
};

const useUpdateCompanySpaceMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ companyId, body }: UpdateCompanySpaceInput) =>
      CompanySpacesService.updateCompanySpace(companyId, body),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: spacesQueries.all().queryKey });
      queryClient.invalidateQueries({ queryKey: ['sidebar'] });
    },
  });
};

export { spacesQueries, useUpdateCompanySpaceMutation };
